export const scheduleConstants = {
    SCHEDULE_FETCHING: 'SCHEDULE_FETCHING',
    SCHEDULE_FETCHED: 'SCHEDULE_FETCHED',
    SCHEDULE_SUBMITTING: 'SCHEDULE_SUBMITTING',
    SCHEDULE_SUBMITTED: 'SCHEDULE_SUBMITTED',
    LIST_OF_SCHEDULES: 'LIST_OF_SCHEDULES',
    GET_SCHEDULE_BY_ID: 'GET_SCHEDULE_BY_ID',
    DESTINATIONS_LIST_FROM_SCHEDULE: 'DESTINATIONS_LIST_FROM_SCHEDULE',
}